<div class="report-page-container">
  <div class="header-container">
    <div class="text-title-2">{{title}}</div>
  </div>

  <div class="table-controls-container">
    <form [formGroup]="filtersForm"
          [ngClass]="{'active': isDrugsDropdownOpened}"
    >
      <app-multiselect-dropdown formControlName="drugs"
                                id="drugs"
                                [id]="'drugs'"
                                [ngClass]="{'actual': isDrugsDropdownOpened}"
                                [label]="'Drug'"
                                [placeholder]="'All Drugs'"
                                (dropDownOpened)="multiselectOpened('drugItemsShowLimit', 'isDrugsDropdownOpened')"
                                (dropDownClosed)="multiselectClosed('drugItemsShowLimit', 'isDrugsDropdownOpened')"
                                [data]="drugsList"
                                [settings]="drugListSettings"
                                [itemsLimit]="drugItemsShowLimit"
                                [loading]="isLoading$ | async"
                                [shouldFilterByNDC]="true"
                                (tabEnterEvent)="focusMultioptionalDropdown('activityMultioptionalDropdown')"
                                
                                #drugsMultiOptionalDropdown
      ></app-multiselect-dropdown>

      <app-schedules-filter *ngIf="enableC3toC5Drugs$ | async"
       class="ml-2 mr-2"
        label="Schedule"
        [control]="filtersForm.controls.schedules">
       </app-schedules-filter>

      <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled"
        class="ml-2"
        label="Location"
        [control]="filtersForm.controls.inventoryLocations">
      </app-inventory-locations-filter>
    </form>

    <div class="header-controls">
      <app-button [text]="'Reset'"
                  styleClass="settings"
                  subStyle="blue"
                  customClasses="px-4 mr-2"
                  [minWidth]="0"
                  [disabled]="areFiltersEmpty() && !originalRecordsList?.length"
                  (clicked)="reset()"
      ></app-button>
      <app-button customClasses="px-4"
                  [text]="'Run Report'"
                  (clicked)="runReport()"
                  [loading]="runningReports$ | async"
      ></app-button>
    </div>
  </div>

  <div class="reports-table-container">
    <div *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && !isReportRunApplied" class="empty-list-container">
      <div class="icon-wrapper">
        <img class="chart-icon" src="assets/icons/icon-chart-active.svg" alt="report-icon"/>
      </div>
      <div class="empty-list-header">Results</div>
      <div class="empty-list-description">
        Your report data will show up here.
      </div>
    </div>

    <app-empty-table *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && isReportRunApplied"
                     [labelValue]="'There are no items to display.'"
                     [topOffset]="290"
    ></app-empty-table>

    <form [formGroup]="reportsTableControlsForm" class="table-controls" *ngIf="originalRecordsList?.length">
      <div class="left-block">
        <app-search-input formControlName="searchValue"
                          [color]="SearchInputColorEnum.Blue"
                          [placeholder]="'Start typing...'"
                          [hideDropdown]="true"
        ></app-search-input>
      </div>

      <div *ngIf="sortedRecordsList.length && inventoryLocationsEnabled" class="right-block">
        <div class="heading">
          Results
        </div>
        <app-button [text]="'By Drug'"
                    styleClass="toggle"
                    [disabled]="isLoading$ | async"
                    [subStyle]="filterResultsBy === 'drug' ? 'active' : 'unactive'"
                    [minWidth]="0"
                    customClasses="px-3"
                    (clicked)="switchFilterResultBy('drug')"
        ></app-button>
        <app-button [text]="'By Location'"
                    styleClass="toggle"
                    [disabled]="isLoading$ | async"
                    [subStyle]="filterResultsBy === 'location' ? 'active' : 'unactive'"
                    [minWidth]="0"
                    customClasses="px-3"
                    (clicked)="switchFilterResultBy('location')"
        ></app-button>
        <app-button [text]="'By Similar'"
          styleClass="toggle"
          [disabled]="isLoading$ | async"
          [subStyle]="filterResultsBy === 'gpi' ? 'active' : 'unactive'"
          [minWidth]="0"
          customClasses="px-3"
          (clicked)="switchFilterResultBy('gpi')"
        ></app-button>
      </div>
    </form>

    <table class="table-primary report-records-table" *ngIf="originalRecordsList?.length && inventoryLocationsEnabled">
      <thead>
      <tr>
        <th class="text-left sort drug" scope="col" *ngIf="filterResultsBy === 'location' || filterResultsBy === 'gpi'" 
          (click)="sortByColumn('friendlyName')">
          Drug
          <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-left sort drug" scope="col" *ngIf="filterResultsBy === 'drug' || filterResultsBy === 'gpi'"
          (click)="sortByColumn('locationName')">
          Location
          <img [class.asc]="tableColumns.locationName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-right sort on-hand" scope="col">
          Total
        </th>
      </tr>
      </thead>
      <tbody #tbody [appOverflowClass]>

      <app-search-empty-splash *ngIf="(isLoading$ | async) !== true && reportsTableControlsForm.get('searchValue')?.value && sortedRecordsList?.length === 0"
                               [searchValue]="reportsTableControlsForm.get('searchValue')?.value"
      ></app-search-empty-splash>

      <ng-container *ngFor="let group of sortedRecordsList; let i = index">
        <tr class="group-header-container" (click)="groupItemsOpened[i] = !groupItemsOpened[i]">
          <td colspan="8">
            <img [class.close]="!groupItemsOpened[i]" class="icon-toggle"
                 src="assets/icons/icon-toggle-chevron-green.svg"
                 alt="toggle-icon"/>
            <div class="group-header">
              <div> {{group.header}}</div>
              <div class="group-total text-right">{{group.totalPerGroup}}</div> 
            </div>
          </td>
        </tr>

        <ng-container *ngIf="groupItemsOpened[i]">
          <tr class="table-row"
              *ngFor="let transaction of group.records; trackBy: trackByFn;"
          >
            <th class="text-left drug" scope="row" *ngIf="filterResultsBy === 'location' || filterResultsBy === 'gpi'">
              <div [title]="transaction['friendlyName']" class="heading">
                {{transaction['friendlyName']}}
              </div>
              <div class="secondary">
                {{transaction['packageNdc']}}
              </div>
            </th>
            <th class="text-left drug" scope="row" *ngIf="filterResultsBy === 'drug' || filterResultsBy === 'gpi'">
              <div class="heading">
                  {{transaction?.locationName}}
              </div>
            </th>
            <td class="text-right on-hand">
              {{transaction?.currentInventoryCount | number}}
            </td>
          </tr>
        </ng-container>

      </ng-container>
      </tbody>
    </table>

    <table class="table-primary report-records-table" *ngIf="originalRecordsList?.length && !inventoryLocationsEnabled">
      <thead>
      <tr>
        <th class="text-left sort drug" scope="col"
          (click)="sortByColumn('friendlyName')">
          Drug
          <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-right sort on-hand" scope="col">
          Total
        </th>
      </tr>
      </thead>
      <tbody #tbody [appOverflowClass]>

      <app-search-empty-splash *ngIf="(isLoading$ | async) !== true && reportsTableControlsForm.get('searchValue')?.value && sortedRecordsList?.length === 0"
                               [searchValue]="reportsTableControlsForm.get('searchValue')?.value"
      ></app-search-empty-splash>

      <ng-container *ngFor="let group of sortedRecordsList; let i = index">
          <tr class="table-row"
              *ngFor="let transaction of group.records; trackBy: trackByFn;"
          >
            <th class="text-left drug" scope="row">
              <div [title]="transaction['friendlyName']" class="heading">
                {{transaction['friendlyName']}}
              </div>
              <div class="secondary">
                {{transaction['packageNdc']}}
              </div>
            </th>
            <td class="text-right on-hand">
              {{transaction?.currentInventoryCount | number}}
            </td>
          </tr>
      </ng-container>
      </tbody>
    </table>

  </div>
  <app-button *ngIf="sortedRecordsList?.length && originalRecordsList?.length"
    customClasses="ml-3 px-4 mr-3 flex-start min-w-[117px]" [text]="'Download'" appMenu [loading]="isFileDownloading"
    [minWidth]="117" justifyTextPosition="left" [autoClose]="'outside'"
    [menuContent]="downloadMenuContent" triggers="manual" #downloadMenu="appMenu"
    (click)="downloadMenu.toggle();$event.stopPropagation();" [ngClass]="(loadingLibertyRxInventory$ | async) ? 'download-btn-left' : 'download-btn'">
    <img [class.opened]="downloadMenu.isOpen()" class="download-btn-icon" src="assets/icons/icon-chevron-down-white.svg"
      alt="chevron-down" />
  </app-button>
  <ng-template #downloadMenuContent>
    <div class="menu-container primary">
      <div (click)="savePDF();downloadMenu.close();$event.stopPropagation()" class="menu-item">
        <div class="option">Export as PDF</div>
      </div>
      <div (click)="saveCSV();downloadMenu.close();$event.stopPropagation()" class="menu-item">
        <div class="option">Save as CSV</div>
      </div>
    </div>
  </ng-template>
</div>
